// @flow

import React from 'react'
import styled from 'styled-components'

import { Headline } from '../../components/typography'

import { myTheme } from '../../styles'

const {
  color, fontSize, fontWeight, breakpoint,
} = myTheme

const Title = styled.h1`
  font-size: ${fontSize.two};

  @media screen and (min-width: ${breakpoint.large}) {
    font-size: ${fontSize.one};
  }
`

const Subtitle = styled.p`
  color: ${color.darkSilver};
  font-weight: ${fontWeight.five};
`

type Props = {
  title: string,
  tags: Array<string>,
}

const Head = ({ title, tags }: Props) => {
  const formatTags = tags.join(', ')
  return (
    <div>
      <Headline>
        <Title className="mb1">{title}</Title>
      </Headline>
      <Subtitle className="mb3 mt0">{formatTags}</Subtitle>
    </div>
  )
}

export default Head



// WEBPACK FOOTER //
// ./src/scenes/works/head.js